/* eslint-disable @typescript-eslint/no-non-null-assertion */

// Takes the condition, request, absent lecs and absent tuts and  credits to give appropriate replies
// Condition => 1: you can miss, 0: you can not miss, -1: you are already out of the course
import { ICourse } from "../inputForm/courseDataList";

export const replier = (condition: number, request?: string, credits?: number, alreadyAbsentLecs?: number, alreadyAbsentTuts?: number, course?: ICourse ) => {

  const random = Math.random() * 10; //Returns a random number from 0 to 9.99999
  const OddGENsCourse = ["GEN341","GEN342","GEN004","GEN333", "GENS442", "GENS341"];
  const courseCode = course?.code.slice(0,3);
  const courseNumber = course?.code.slice(4,7);
  const courseName = courseCode! + courseNumber;

  if (credits === 4) {
    if (random > 0 && random < 3)
      return (`Really dude ? It's a 4-credit hours course, go attend you classes. Iam Joking, to be honest I don't have the recipe to calculate the absence for
      4-credits courses.`)

    else if (random > 3 && random < 6)
      return (`Asking for a 4-credit hours course man ? Do not miss these courses; they have a big gravity in the GPA. Joking friend, I dunno how to calculate
      4-credit hours courses.`)

    else
      return (`I know everything about the absence system except for 4-credit hours courses. So, I am sorry I can not help with that.`)
  }

  else if (condition === 1) {
    const genn = ((credits === 1 || (credits===2 && courseCode === "GEN")  && !OddGENsCourse.includes(courseName)))

    if (random >= 0 && random <= 3)
      return (
        `Yes, you can miss the ${request}. You have only missed ${alreadyAbsentLecs} lectures${!genn ? ` and ${alreadyAbsentTuts} tutorials` : ``}, 
        and since this is a ${credits}-credits course; you can safely miss ${request}.`
      )

    else if (random > 3 && random <= 6)
      return (
        `Of course, you can miss the ${request}. You have already missed ${alreadyAbsentLecs} lectures ${!genn ? `and ${alreadyAbsentTuts} tutorials` : ``} as you said. 
          So, you can safely miss ${request}. It's a ${credits}-credits course, so no worries.`
      )

    else 
      return (`${course?.name} is a ${credits}-credits course, and you missed only ${alreadyAbsentLecs} lectures  ${!genn ? `and ${alreadyAbsentTuts} tutorials` : ``}
        within in. So, you can skip the ${request} with no worries, it is safe my friend.`)
  }

  else if (condition === 0) {
    const genn = ((credits === 1 || (credits===2 && courseCode === "GEN")  && !OddGENsCourse.includes(courseName)))

    if (random >= 0 && random <= 3)
      return (
        `No, you can not miss the ${request}, and if you did you will be deprived from the course. As I see you have missed ${alreadyAbsentLecs} lectures
          ${!genn ? `and ${alreadyAbsentTuts} tutorials`: ``} in this course and missing the ${request} will make you elimanated from the course So, take care.`
      )
      
    else if (random > 3 && random <= 6)
      return (
        `No, no, no. You can not miss it. You can not miss the ${request}, and if you did you will be deprived from the course and lose the right to enter the 
        final exam. You have already missed ${alreadyAbsentLecs} lectures${!genn ? ` and ${alreadyAbsentTuts} tutorials`: ``}, and missing the ${request} will make you 
        beyond the limits so go attend.`
      )

    else 
      return (
        `No, you are not allowed to miss the ${request} in ${course?.name} you missed ${alreadyAbsentLecs} lectures${!genn ? ` and ${alreadyAbsentTuts} tutorials` : ``}, and adding
        the ${request} to your absence sheet will make you deprived from the course.`
      )
  }

  else if (condition === -1) {
    const genn = ((credits === 1 || (credits===2 && courseCode === "GEN")  && !OddGENsCourse.includes(courseName)))

    if (random >= 0 && random <= 3)
      return (
        `Hey man! You are already deprived from the course. You told me that you have missed ${alreadyAbsentLecs} lectures${!genn ? ` and ${alreadyAbsentTuts} tutorials`: ``},
        that number is beyond the limits please contact the administration ASAP.`
      )

    else if (random > 3 && random <= 6)
      return (
        `OMG! You are already deprived from the course. You told me that you have missed ${alreadyAbsentLecs} lectures${!genn ? ` and ${alreadyAbsentTuts} tutorials`: ``}.
        If it is right, contact the administration ASAP to discuss your situation.`
      )

    else 
      return (
        `I hope you had a typo when you told me that you have missed ${alreadyAbsentLecs} lectures${!genn ? ` and ${alreadyAbsentTuts} tutorials`: ``}. If this is right and you 
        have really missed ${alreadyAbsentLecs} lectures and ${alreadyAbsentTuts} tutorials; that means that you have already been deprived from the course, and
        you should contact the administration ASAP to find a solution.`
      )
  
  }

  else if (condition === 2) {
    if (credits === 3)
      return(
        `So you are asking how it works. This is a 3-credits course, and all 3-credits courses work the same. You have 10 points; each lecture count for 2 points,
        and each tutorial count for 1 point. It does not depend on the actual timespan of the lecture or the tutorial. For example if you have a 3-credits course
        with 3 hours (180 minutes) tutorial, and only 2 hours (120 minutes) lecture; the lecture will stay counting for 2 points and the tutorial will count for 
        1 point despite having longer time. I know it's not logical, but this is the way they are working with.`);

    else if ((credits === 1 || (credits===2 && courseCode === "GEN")  && !OddGENsCourse.includes(courseName)))
      return(
        `Okay, These type of courses are so easy to know their absence rules. You only have lectures with no tutorials and you have 3 points to miss while each
        lecture counts for one point. You can reach 3 points and be safe and you can not go beyond 3. i.e you can miss by maximum 3 lectures only.`
      )

    else if ((credits ===2 && courseCode !== "GEN") || OddGENsCourse.includes(courseName)) 
      return(
        `Okay, These is a 2-credits course. I will till you how it works. You have 6 points, and each of lecture or tutorial count for 1 point, You can reach 6 points
        but you can not go beyond this. It does not depend on the timespan of the lecture of the tutorial, both will cost you one point of the 6 points if you missed
        one of them.`
      )

  }
}